import React, { type ReactNode, useRef, createContext } from 'react';

import { useSectionsManager } from 'src/app/v1/views/hooks/useSectionsManager';
import type { SectionRef, SectionRefs } from 'src/types/sections';

type Context = {
  sectionsManager: ReturnType<typeof useSectionsManager>;
  sectionRefs: SectionRefs;
};

export const EditFlowSectionsManagerContext = createContext<Context>({
  sectionsManager: {} as ReturnType<typeof useSectionsManager>,
  sectionRefs: {},
});

interface Props {
  children: ReactNode;
}

export const EditFlowSectionsManagerProvider = ({ children }: Props) => {
  const classifySectionRef = useRef<SectionRef>(null);
  const privateAdSectionRef = useRef<SectionRef>(null);
  const brandingSectionRef = useRef<SectionRef>(null);
  const candidateSearchResultsSectionRef = useRef<SectionRef>(null);
  const jobDescriptionSectionRef = useRef<SectionRef>(null);
  const manageCandidateApplicationsSectionRef = useRef<SectionRef>(null);
  const standOutUpsellSectionRef = useRef<SectionRef>(null);

  const sectionRefs = {
    classifySectionRef,
    privateAdSectionRef,
    brandingSectionRef,
    candidateSearchResultsSectionRef,
    jobDescriptionSectionRef,
    manageCandidateApplicationsSectionRef,
    standOutUpsellSectionRef,
  };

  const sectionsManager = useSectionsManager({ sectionRefs });

  return (
    <EditFlowSectionsManagerContext.Provider
      value={{ sectionsManager, sectionRefs }}
    >
      {children}
    </EditFlowSectionsManagerContext.Provider>
  );
};
